import { cilLanguage } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react-pro'
import i18next from 'i18next'
import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { fetchLanguages } from '../../actions'
import { CHANGE_LANGUAGE_DATA } from '../../actions/actionType'
import { AuthContext } from '../../context/AuthContext'

const AppHeaderLanguages = () => {
  const dispatch = useDispatch()
  const { auth } = useContext(AuthContext)
  const { i18n, t } = useTranslation('header')
  const languages = useSelector((state) => state.languages.languages)
  const currentLang = useSelector((state) => state.languages.current)

  const changeLanguage = (languageSel) => {
    if (languageSel === i18n.language) {
      return
    }
    i18n.changeLanguage(languageSel).then((r) => {
      dispatch({
        type: CHANGE_LANGUAGE_DATA,
        payload: languages.find((l) => l.locale === languageSel),
      })
    })
  }

  useEffect(() => {
    if (auth.isLoggedIn) {
      dispatch(fetchLanguages(languages))
    }
  }, [])

  useEffect(() => {
    if (auth && languages && languages.length > 0 && !currentLang.length) {
      const currentLang = languages.find((l) => l.id === auth.language_id)
      if (currentLang) {
        dispatch({ type: CHANGE_LANGUAGE_DATA, payload: currentLang })
        i18next.changeLanguage(currentLang.locale)
      }
    }
  }, [languages])

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
        <CIcon icon={cilLanguage} size="lg" />
      </CDropdownToggle>
      <CDropdownMenu>
        {languages &&
          currentLang &&
          languages.map((l, i) => (
            <CDropdownItem
              role="button"
              key={i}
              value={l.locale}
              onClick={() => changeLanguage(l.locale)}
            >
              {l.locale === currentLang.locale ? <strong>{t(l.locale)}</strong> : t(l.locale)}
            </CDropdownItem>
          ))}
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderLanguages
